import React, { useEffect, useState } from 'react';
import { useGlobalStyles, usePrimaryModal } from 'utils';
import { FullTable, ItemPriceTitle } from 'components';
import { collectionsBody, collectionsHead } from './constants';
import { LoadDetailSwitcher } from '../../../../pages';
import { agentActions, branchActions, carrierActions, factoringActions, officeActions } from '../../../../store';

export const CollectionsTable = ({ info }) => {
  const globalStyle = useGlobalStyles();
  const { openPrimary } = usePrimaryModal();

  return (
    <div style={{marginTop: 0}} className={globalStyle.tableWrapperNoShadow}>
      <div style={{ marginBottom: '20px' }} className={globalStyle.spaceBetween}>
        <div />
        <div>
          <ItemPriceTitle name={'Outstanding Debt:'} value={`$ ${info?.outstandingDebt}`} styles={{margin: 0}} />
        </div>
      </div>
      <div>
        <FullTable
          head={collectionsHead}
          body={collectionsBody}
          loadingType={'GET_PAYMENTS_CARRIER'}
          list={info?.debt}
          noText={'Collections'}
          handleClick={(item) =>
            openPrimary(<LoadDetailSwitcher loadId={item?.loadId} />)
          }
          clickType={'item'}
        />
      </div>
    </div>
  );
};